import { render, staticRenderFns } from "./refundRecordMobile.vue?vue&type=template&id=fdd5cb12&scoped=true"
import script from "./refundRecordMobile.vue?vue&type=script&lang=js"
export * from "./refundRecordMobile.vue?vue&type=script&lang=js"
import style0 from "./refundRecordMobile.vue?vue&type=style&index=0&id=fdd5cb12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd5cb12",
  null
  
)

export default component.exports